module.exports = __webpack_public_path__ + "static/media/image_dashboard_white.32477473.svg";